import { Checkbox, CardContent, Typography, TextField } from "@mui/material";
import ImageUpload from "./ImageUpload";
import CloseIcon from "@mui/icons-material/Close";

const AddFooters = ({
  sampleFooters,
  Footers,
  handleCheckBox,
  handleFooters,
  uploadImages,
  close,
  popFooterCount,
  key
}) => {

  let remainingFooters = close !== 0 ? sampleFooters.filter(ele => !Footers.slice(0, close).map(item => item.sheets).flat().includes(ele)) : sampleFooters;
  if(remainingFooters.length === 0 || (remainingFooters.length===1 && remainingFooters.includes('All Pages'))){
    popFooterCount(close);
  }
  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  const handleChecked = (close, footer) => {
    const Footersheet = Footers.find(ele => ele.footer === close);
    if(Footersheet === undefined){
      return false
    }
    let RefinedSampleFooters = remainingFooters.filter((head)=> head !== 'All Pages');
    let all_present = RefinedSampleFooters.every(ele => Footersheet.sheets.includes(ele)) 
    if(Footersheet){
      return Footersheet.sheets.includes(footer) || Footersheet.sheets.includes('All Pages') || all_present || false;
    } else {
      return false
    }
  }

  return (
    <CardContent>
      <div
            style={{
                display: "flex",
                justifyContent: "space-between", // Distributes space between text and icon
                alignItems: "center", // Vertically centers the content
                padding: "0 10px", // Adds padding on the left and right
            }}
        >
            <Typography
                className="font-size-16 custom-font-600"
                sx={{
                    fontSize: 16,
                    lineHeight: "20px",
                    color: "#000000",
                }}
                gutterBottom
            >
                Add Footer to:
            </Typography>
            {close !== 0 &&  <CloseIcon 
                className="custom-redcolor ml-1 mt-1" 
                style={{ cursor: "pointer", backgroundColor: 'lightpink', borderRadius: '50%' }} 
                onClick={()=>{popFooterCount(close)}}
            /> }
        </div>
      <div className="d-flex flex-wrap justify-content-between">
        {remainingFooters.map((footer, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              flex: "0 1 100px", // Adjust the width as needed
              marginBottom: "5px", // Adds spacing between rows
            }}
          >
            <Checkbox
              {...label}
              name="sheet1"
              value={footer}
              onChange={(e)=>handleCheckBox(e, close)}
              checked={
                handleChecked(close, footer)
              }
              sx={{
                "&.Mui-checked": {
                  color: "#03565A ", // Color when checked
                },
              }}
            />
            <h6 className="mr-2 mt-2">{footer}</h6>
          </div>
        ))}
      </div>
      <div className="mt-2 ">
        <TextField
          onChange={(e)=>handleFooters(e, close)}
          multiline
          maxRows={5}
          name="footer1"
          placeholder="footer Data"
          variant="outlined"
          className="w-100 finalise-textcolor rounded"
        />
      </div>
      <div>
        <ImageUpload uploadImages={uploadImages} name={"image1"} />
      </div>
    </CardContent>
  );
};

export default AddFooters;
